const ONE_SECOND_IN_MS = 1000;
const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;
const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
const ONE_DAY_IN_MS = 24 * ONE_HOUR_IN_MS;

const MS = Object.freeze({
  second: ONE_SECOND_IN_MS,
  minute: ONE_MINUTE_IN_MS,
  hour: ONE_HOUR_IN_MS,
  day: ONE_DAY_IN_MS,
});

export default MS;
